(() => {
  const OPEN_DELAY = 80;
  const CLOSE_DELAY = 220;
  const desktop = window.matchMedia('(min-width: 769px)');

  function initMega(item) {
    if (item.dataset.ctReady) return;
    item.dataset.ctReady = 'true';

    const trigger = item.querySelector('.ct-mega-trigger');
    const panel = item.querySelector('[data-ct-mega-panel]');
    if (!trigger || !panel) return;

    let openTimer;
    let closeTimer;

    const isOpen = () => item.classList.contains('is-open');

    const open = () => {
      clearTimeout(closeTimer);
      if (isOpen()) return;
      const top = panel.getBoundingClientRect().top;
      item.style.setProperty('--ct-mega-top', `${Math.max(top, 0)}px`);
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      clearTimeout(openTimer);
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    };

    item.addEventListener('mouseenter', () => {
      if (!desktop.matches) return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(open, OPEN_DELAY);
    });

    item.addEventListener('mouseleave', () => {
      if (!desktop.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, CLOSE_DELAY);
    });

    trigger.addEventListener('click', (event) => {
      if (!desktop.matches || isOpen()) return;
      event.preventDefault();
      open();
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === ' ') {
        event.preventDefault();
        open();
        panel.querySelector('a[href]')?.focus();
      }
    });

    item.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) {
        close();
        trigger.focus();
      }
    });

    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) close();
    });

    document.addEventListener('click', (event) => {
      if (isOpen() && !item.contains(event.target)) close();
    });

    desktop.addEventListener('change', close);

    document.addEventListener('shopify:block:select', (event) => {
      if (panel.contains(event.target)) open();
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      if (panel.contains(event.target)) close();
    });
  }

  function initMobile(menu) {
    if (menu.dataset.ctReady) return;
    menu.dataset.ctReady = 'true';

    const toggles = menu.querySelectorAll('button.ct-mob__toggle[aria-controls]');

    const setOpen = (button, state) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      button.setAttribute('aria-expanded', String(state));
      panel.hidden = !state;
    };

    toggles.forEach((button) => {
      button.addEventListener('click', () => {
        const willOpen = button.getAttribute('aria-expanded') !== 'true';
        toggles.forEach((other) => setOpen(other, false));
        setOpen(button, willOpen);
      });
    });
  }

  function init(root = document) {
    root.querySelectorAll('[data-ct-mega]').forEach(initMega);
    root.querySelectorAll('[data-ct-mobile-menu]').forEach(initMobile);
  }

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
